module.exports = __webpack_public_path__ + "static/modesta-bc-05-41bc7c5ee3dea8698b887da99cf9cb63.png";